import { ConfirmDialog } from "primereact/confirmdialog";
import { Toast } from "primereact/toast";
import React, { useEffect, useRef, useState } from "react";

import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { FileUpload } from "primereact/fileupload";
import { useDispatch, useSelector } from "react-redux";
import TableDataComponent from "../../components/parking-excel/TableDataComponent";
import TotalLineComponent from "../../components/parking-excel/TotalLineComponent";
import { setLayoutDashboardTitle } from "../../store/ui-slice";
import { useNavigate } from "react-router-dom";
import useAPIRequest from "../../custom_hooks/simple/useAPIRequest";
import { format } from "date-fns";
import onErrorToast from "../../utils/OnErrorToast";
import onSuccessToast from "../../utils/OnSuccessToast";
import { Dropdown } from "primereact/dropdown";
import copyToClipboard from "../../utils/parkir-import-excel/CopyToClipboard";

const title = "Upload Data";

const filterOptions = [
  { name: "Semua", value: "semua" },
  { name: "Mobil", value: "mobil" },
  { name: "Sepeda", value: "sepeda" },
];

const UploadDataPage = (props) => {
  const navigate = useNavigate();
  const permissions = useSelector((state) => state.auth.permissions);

  const uploadRef = useRef(null);
  const toastRef = useRef(null);
  const dispatch = useDispatch();
  const [date, setDate] = useState(new Date());
  const [data, setData] = useState([]);
  const [selectedFilter, setSelectedFilter] = useState(filterOptions[0].value);
  const { requestGet, requestPost, loading } = useAPIRequest();

  useEffect(() => {
    if (!permissions.includes("view uploaddata")) {
      navigate("/");
    }
    dispatch(setLayoutDashboardTitle({ title }));
  }, []);

  const generateFilter = () => {
    let filter = "";
    const nextDate = new Date(date);
    nextDate.setDate(nextDate.getDate() + 1);
    filter += `keluar_tanggal:>=:${format(
      date,
      "yyyy-MM-dd"
    )} 00:00:00;keluar_tanggal:<:${format(nextDate, "yyyy-MM-dd")} 00:00:00`;

    if (selectedFilter && selectedFilter !== "semua") {
      filter += `;jenis:contains:%${selectedFilter}%`;
    }

    return filter;
  };

  const reloadData = () => {
    setData([]);
    requestGet({
      fullUrl: "api/transaksi/dataparkir/data",
      params: {
        filter: generateFilter(),
        page: 1,
        take: 1000000,
        order: "id",
        order_method: "ASC",
      },
      onSuccess: ({ pagination, message, data }) => {
        if (data) {
          for (let i = 0; i < data.length; i++) {
            data[i].no = i + 1;
          }
          setData(data);
        }
      },
      onError: ({ message, data }) => {},
    });
  };

  const uploadData = async (file) => {
    var today = new Date();
    var yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);
    var formattedDate = yesterday.toISOString().slice(0, 10);

    const postResult = await requestPost({
      fullUrl: "api/transaksi/dataparkir/import",
      isForm: true,
      body: {
        // tanggal: format(new Date(), "yyyy-MM-dd"),
        tanggal: formattedDate,
        file: file,
      },
      onSuccess: ({ message, data: d }) => {
        if (d) {
          // const copyData = [...datas];
          // copyData[index] = d;
          // setDatas(copyData);

          onSuccessToast({
            toast: toastRef,
            message: "Data berhasil di-import",
            data: {},
          });
        }
      },
      onError: ({ message, data }) => {
        onErrorToast({
          toast: toastRef,
          message: "Gagal meng-import data",
          data: {},
        });
      },
    });
  };

  const uploadHandler = (event) => {
    const { files, options } = event;
    const formData = new FormData();
    let file;
    for (let i = 0; i < files.length; i++) {
      file = files[i];
    }
    uploadData(file);
  };

  const reloadHandler = (event) => {
    reloadData();
  };

  const handleCopyData = () => {
    copyToClipboard({
      fields: [
        "no",
        "jenis",
        "masuk_tanggal",
        "masuk_op",
        "keluar_tanggal",
        "keluar_kasir",
        "nomor_plat",
        "lama",
        "jumlah",
      ],
      data,
    });
    onSuccessToast({
      toast: toastRef,
      message: "Data berhasil di-copy",
      data: {},
    });
  };

  return (
    <div className={`col-start-start p-4 gap-4 w-100`}>
      <Toast ref={toastRef} />
      <ConfirmDialog />
      <div className="elevated-card col-start-start w-full gap-4">
        {/* header - tanggal & upload */}
        <div className="row-between-center gap-3 w-full">
          <div className="row-start-center gap-2">
            <span>Tanggal</span>
            <Calendar
              className="max-w-[12rem]"
              value={date}
              onChange={(e) => setDate(e.value)}
              showIcon
            />
            <Dropdown
              value={selectedFilter}
              onChange={(e) => setSelectedFilter(e.value)}
              options={filterOptions}
              optionLabel="name"
              className="w-[10rem]"
            />
            <Button
              label="Load Data"
              icon="pi pi-refresh"
              loading={loading}
              onClick={reloadHandler}
            />
          </div>
          <div className="row-start-center gap-4">
            <div className="row-start-center gap-2">
              <FileUpload
                ref={uploadRef}
                mode="basic"
                name="demo[]"
                // url="/api/upload"
                accept="*"
                maxFileSize={20971520}
                customUpload
                uploadHandler={uploadHandler}
                disabled={loading}
              />
              <Button
                severity="danger"
                icon="pi pi-times"
                onClick={(e) => uploadRef.current.clear()}
                loading={loading}
              />
            </div>
            <Button label="Copy" icon="pi pi-copy" onClick={handleCopyData} />
          </div>
        </div>

        {/* total */}
        <TotalLineComponent
          listData={data}
          labelField={"jenis"}
          totalField={"jumlah"}
        />

        {/* tabel */}
        <TableDataComponent data={data} />
      </div>
    </div>
  );
};

export default UploadDataPage;
